import React, { useState } from 'react';
import styled from 'styled-components';
import { FormToggle } from 'ui-kit/SmartForm';
import IntlStore from 'stories/IntlStore';
import Copy from 'assets/smallcopy.svg';
import WhitePluse from '../../../../../assets/plusWhite.svg';
import Shiotify from '../../../../../assets/shiotify.svg';
import Youthube from '../../../../../assets/YouTubeIcon.svg';
import Instagram from '../../../../../assets/instagram.svg';

interface CardProps {
  title?: string;
  toggle?: boolean;
  name?: string;
  value?: string;
  onChange?: (value: string[]) => void; 
}
interface AddBoxProps {
  disabled?: boolean;
}

export const Card: React.FC<CardProps> = ({
  title = '',
  toggle = false,
  name,
  value = '',
  onChange,
}) => {
  const [links, setLinks] = useState<string[]>(value && Array.isArray(value) ? value : ['']);

  React.useEffect(() => {
    if (value && Array.isArray(value)) {
      setLinks(value.length > 0 ? value : ['']);
    }
  }, [value]);
  
  const handleChange = (index: number, newValue: string) => {
    const updatedLinks = [...links];
    updatedLinks[index] = newValue;
    setLinks(updatedLinks);
  
    if (name) {
      onChange?.( updatedLinks);
    }
  };
  
  const handleAdd = () => {
    setLinks([...links, '']);
  };

  const handleCopy = (link: string) => {
    if (link) navigator.clipboard.writeText(link);
  };


  const getPlatformIcon = (link: string) => {
    if (!link) return null;
    const val = link.toLowerCase();

    if (val.includes('youtube') || val.includes('youtu.be')) return <Youthube />;
    if (val.includes('spotify') || val.includes('shiotify')) return <Shiotify />;
    if (val.includes('instagram')) return <Instagram />;

    return null;
  };
  const lastLink = links[links.length - 1];



  return (
    <Content>
      <TitleBox>
        {title}
        {toggle && (
          <ToggleWrapper>
            <FormToggle
              id="sort_platform_links_by_click"
              name="sort_platform_links_by_click"
              label={IntlStore.intl.formatMessage({
                id: 'SmartLink.SortByClicks',
                defaultMessage: 'Sort by clicks',
              })}
              tooltip="tooltip"
            />
            <TooltipBox >Turn Sort by clicks — your fans’ favorite platforms will always show up first. It’s a simple way to see where your music gets the most love and make it even easier for listeners to hit play
              
            </TooltipBox>
          </ToggleWrapper>
        )}

      </TitleBox>
      {
        links.map((link, index) => (
          <InputBox key={index}>
            {link && <IconBox>{getPlatformIcon(link)}</IconBox>}
            <Input
              name={name}
              value={link}
              onChange={(e) => handleChange(index, e.target.value)}
              placeholder={title}
            />

            <CopyBox onClick={() => handleCopy(link)}>
              <Copy />
            </CopyBox>
          </InputBox>
        ))
      }

      <AddBox
        disabled={!lastLink || !getPlatformIcon(lastLink)}
        onClick={handleAdd}
      >
        <WhitePluse />
        <span
          style={{
            color: !lastLink || !getPlatformIcon(lastLink)
              ? 'rgba(103, 119, 255, 0.5)'
              : 'rgba(103, 119, 255, 1)',
          }}
        >
          Add {title}
        </span>
      </AddBox>
    </Content>
  );
};


const Content = styled.div`
  width: 100%;
  min-height: 148px;
  border-radius: 25px;
  padding: 21px 8px 17px 18px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const TitleBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
`;

const InputBox = styled.div`
  width: 100%;
  display: flex;
  gap: 7px;
  align-items: center;
  position: relative;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding: 0 11px 0 13px;
`;

const Input = styled.input`
  width: 90%;
  height: 39px;
 
  border: none;
  outline: none;
`;

const IconBox = styled.div`
  // position: absolute;
  // right: 60px;
  // width: 16px;
  // height: 16px;
`;

const CopyBox = styled.div`
  position: absolute;
  right: 12px;
  cursor: pointer;
  width: 12px;
  height: 12px;
`;

const AddBox = styled.div<AddBoxProps>`
  width: 100%;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-family: 'SF Pro Display', sans-serif;
  font-weight: 600;
  font-size: 13px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: opacity 0.2s, background-color 0.2s;
  margin-top: 3px;
`;

const ToggleWrapper = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-block;

  &:hover > .tooltip {
    visibility: visible;
    opacity: 1;
    cursor: pointer;
  }
`;

const TooltipBox = styled.div`
  cursor: pointer;
  position: absolute;
  bottom: 100%;
  right: 10px;
  background: rgba(226, 229, 255, 1);
  color: rgba(0, 0, 0, 1);
  padding: 18px 5px 13px 9px;
  border-radius: 4px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 10;
  width: 261px;
  height: 131px;
  border-radius: 15px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0%;


  
  ${ToggleWrapper}:hover & {
    opacity: 1;
  }

  &::after {
    display: none;
  }
`;

